import { t } from 'ttag'
import { CustomTypeCategory } from '../../services/CustomTypes'
import { unitsDisplayDurationCalorieLong } from '../../common/helpers/units'

/**
 * Array of all available activity types for challenges.
 * Each activity type includes:
 * - value: The CustomTypeCategory enum value
 * - label: Display name for the activity
 * - usesIntegration: Whether this activity type uses device integration (true) or manual entry (false)
 */
export const activityTypes = [
  {
    value: CustomTypeCategory.STEPS,
    label: t`Steps`,
    usesIntegration: true,
    //activeIcon: StepsActiveIcon,
    //inactiveIcon: StepsInactiveIcon,
  },
  {
    value: CustomTypeCategory.DISTANCE,
    label: t`Distance`,
    usesIntegration: true,
    //activeIcon: DistanceActiveIcon,
    //inactiveIcon: DistanceInactiveIcon,
  },
  {
    label: t`Wellness points`,
    description: t`Combining different activities`,
    value: CustomTypeCategory.POINTS,
    usesIntegration: true,
    //activeIcon: PointsActiveIcon,
    //inactiveIcon: PointsInactiveIcon,
  },
  {
    label: t`Total wellness points`,
    description: t`Combining different challenges`,
    value: CustomTypeCategory.TOTAL_POINTS,
    usesIntegration: true,
    //activeIcon: PointsActiveIcon,
    //inactiveIcon: PointsInactiveIcon,
  },
  {
    label: t`Water drinking`,
    value: CustomTypeCategory.WATER_DRINKING,
    usesIntegration: false,
    //activeIcon: WaterDrinkingActiveIcon,
    //inactiveIcon: WaterDrinkingInactiveIcon,
  },
  {
    value: CustomTypeCategory.CYCLING,
    label: t`Cycling`,
    usesIntegration: true,
    //activeIcon: CyclingActiveIcon,
    //inactiveIcon: CyclingInactiveIcon,
  },
  {
    value: CustomTypeCategory.CALORIES,
    label: unitsDisplayDurationCalorieLong,
    usesIntegration: true,
    //activeIcon: CaloriesActiveIcon,
    //inactiveIcon: CaloriesInactiveIcon,
  },
  {
    value: CustomTypeCategory.SLEEP,
    label: t`Sleep`,
    usesIntegration: false,
    //activeIcon: SleepActiveIcon,
    //inactiveIcon: SleepInactiveIcon,
  },
  {
    value: CustomTypeCategory.OUTDOOR_TIME,
    label: t`Outdoor time`,
    usesIntegration: false,
    //activeIcon: OutdoorActiveIcon,
    //inactiveIcon: OutdoorInactiveIcon,
  },
  {
    value: CustomTypeCategory.MINDFULNESS,
    label: t`Mindfulness`,
    usesIntegration: false,
    //activeIcon: MindfulnessActiveIcon,
    //inactiveIcon: MindfulnessInactiveIcon,
  },
  {
    value: CustomTypeCategory.PLANKING,
    label: t`Planking`,
    usesIntegration: false,
    //activeIcon: PlankingActiveIcon,
    //inactiveIcon: PlankingInactiveIcon,
  },
  {
    value: CustomTypeCategory.RUNNING,
    label: t`Running`,
    usesIntegration: true,
    //activeIcon: RunningActiveIcon,
    //inactiveIcon: RunningInactiveIcon,
  },
  {
    value: CustomTypeCategory.WALKING,
    label: t`Walking`,
    usesIntegration: true,
    //activeIcon: WalkingActiveIcon,
    //inactiveIcon: WalkingInactiveIcon,
  },
  {
    value: CustomTypeCategory.SWIMMING,
    label: t`Swimming`,
    usesIntegration: true,
    //activeIcon: SwimmingActiveIcon,
    //inactiveIcon: SwimmingInactiveIcon,
  },
  {
    value: CustomTypeCategory.YOGA,
    label: t`Yoga`,
    usesIntegration: true,
    //activeIcon: YogaActiveIcon,
    //inactiveIcon: YogaInactiveIcon,
  },
  {
    value: CustomTypeCategory.STRENGTH_TRAINING,
    label: t`Strength training`,
    usesIntegration: true,
  },
  {
    value: CustomTypeCategory.EXERCISE,
    label: t`Exercise minutes`,
    usesIntegration: true,
    //activeIcon: ExerciseActiveIcon,
    //inactiveIcon: ExerciseInactiveIcon,
  },
  {
    value: CustomTypeCategory.INTENSIVE_MINUTES,
    label: t`Intensive minutes`,
    usesIntegration: true,
    //activeIcon: MinutesActiveIcon,
    //inactiveIcon: MinutesInactiveIcon,
  },
  {
    value: CustomTypeCategory.ALL,
    label: t`Activity index`,
    //description: t`YuMuuv formula, requires heart rate data`,
    usesIntegration: true,
    //activeIcon: ActivityIndexActiveIcon,
    //inactiveIcon: ActivityIndexInactiveIcon,
  },
  // New manual entry challenges.
  // Book reading
  {
    value: CustomTypeCategory.BOOK_READING,
    label: t`Book reading`,
    usesIntegration: false,
  },
  // Encouraging someone
  {
    value: CustomTypeCategory.ENCOURAGING,
    label: t`Encouraging someone`,
    usesIntegration: false,
  },
  // Car-free days
  {
    value: CustomTypeCategory.CAR_FREE_DAYS,
    label: t`Car-free days`,
    usesIntegration: false,
  },
  // Alcohol abstinence
  {
    value: CustomTypeCategory.ALCOHOL_ABSTINENCE,
    label: t`Alcohol abstinence`,
    usesIntegration: false,
  },
  // Squatting
  {
    value: CustomTypeCategory.SQUATTING,
    label: t`Squatting`,
    usesIntegration: false,
  },
  // Contrast shower
  {
    value: CustomTypeCategory.CONTRAST_SHOWER,
    label: t`Contrast shower`,
    usesIntegration: false,
  },
  // Finance tracking
  {
    value: CustomTypeCategory.FINANCE_TRACKING,
    label: t`Finance tracking`,
    usesIntegration: false,
  },
  // Healthy cooking
  {
    value: CustomTypeCategory.HEALTHY_COOKING,
    label: t`Healthy cooking`,
    usesIntegration: false,
  },
  // Deep breathing
  {
    value: CustomTypeCategory.DEEP_BREATHING,
    label: t`Deep breathing`,
    usesIntegration: false,
  },

  // Daily Journaling
  {
    value: CustomTypeCategory.DAILY_JOURNALING,
    label: t`Daily journaling`,
    usesIntegration: false,
  },
  // Push-Ups
  {
    value: CustomTypeCategory.PUSH_UPS,
    label: t`Push-ups`,
    usesIntegration: false,
  },
  // Pull-Ups
  {
    value: CustomTypeCategory.PULL_UPS,
    label: t`Pull-ups`,
    usesIntegration: false,
  },
  // Creative Arts
  {
    value: CustomTypeCategory.CREATIVE_ARTS,
    label: t`Creative arts`,
    usesIntegration: false,
  },
  // Socializing with Friends
  {
    value: CustomTypeCategory.SOCIALIZING_WITH_FRIENDS,
    label: t`Socializing with friends`,
    usesIntegration: false,
  },
  // Cold Plunge
  {
    value: CustomTypeCategory.COLD_PLUNGE,
    label: t`Cold plunge`,
    usesIntegration: false,
  },
  // Intermittent Fasting
  {
    value: CustomTypeCategory.INTERMITTENT_FASTING,
    label: t`Intermittent fasting`,
    usesIntegration: false,
  },
  // Gratitude Journaling
  {
    value: CustomTypeCategory.GRATITUDE_JOURNALING,
    label: t`Gratitude journaling`,
    usesIntegration: false,
  },
  // Language learning
  {
    value: CustomTypeCategory.LANGUAGE_LEARNING,
    label: t`Language learning`,
    usesIntegration: false,
  },
  // Hobby Development
  {
    value: CustomTypeCategory.HOBBY_DEVELOPMENT,
    label: t`Hobby development`,
    usesIntegration: false,
  },
  // Natural Light Exposure
  {
    value: CustomTypeCategory.NATURAL_LIGHT_EXPOSURE,
    label: t`Natural light exposure`,
    usesIntegration: false,
  },
  // Smoking Cessation
  {
    value: CustomTypeCategory.SMOKING_CESSATION,
    label: t`Smoking cessation`,
    usesIntegration: false,
  },
  // Phone-Free Time
  {
    value: CustomTypeCategory.PHONE_FREE_TIME,
    label: t`Phone-free time`,
    usesIntegration: false,
  },
  // Caffeine Reduction
  /*{
    value: CustomTypeCategory.CAFFEINE_REDUCTION,
    label: t`Caffeine reduction`,
    usesIntegration: false,
  },*/
  // Screen-Free Meals
  {
    value: CustomTypeCategory.SCREEN_FREE_MEALS,
    label: t`Screen-free meals`,
    usesIntegration: false,
  },
  // Daily Flossing
  {
    value: CustomTypeCategory.DAILY_FLOSSING,
    label: t`Daily flossing`,
    usesIntegration: false,
  },
  // Stress Level Monitoring
  /*{
    value: CustomTypeCategory.STRESS_LEVEL_MONITORING,
    label: t`Stress level monitoring`,
    usesIntegration: false,
  },*/
  // Mood Tracking
  /*{
    value: CustomTypeCategory.MOOD_TRACKING,
    label: t`Mood tracking`,
    usesIntegration: false,
  },*/
  // CUSTOM
  {
    value: CustomTypeCategory.CUSTOM,
    label: t`Custom`,
    usesIntegration: false,
    //activeIcon: CustomActiveIcon,
    //inactiveIcon: CustomInactiveIcon,
  },
]

/**
 * Extended array of activity types that includes the base activityTypes
 * plus additional custom and bonus point types.
 * Used for challenge configuration where custom and bonus options are available.
 */
export const activityTypesWithCustomAndBonus = [
  ...activityTypes,
  {
    value: CustomTypeCategory.CUSTOM_SIMPLE,
    label: `${t`Custom`} (${t`simple`.toLowerCase()})`,
    usesIntegration: false,
  },
  {
    value: CustomTypeCategory.CUSTOM_WITH_AMOUNT,
    label: `${t`Custom`} (${t`with amount`.toLowerCase()})`,
    usesIntegration: false,
  },
  {
    value: CustomTypeCategory.BONUS_SIMPLE,
    label: `${t`Bonus points`} (${t`simple`.toLowerCase()})`,
    usesIntegration: false,
  },
  {
    value: CustomTypeCategory.BONUS_WITH_AMOUNT,
    label: `${t`Bonus points`} (${t`with amount`.toLowerCase()})`,
    usesIntegration: false,
  },
]
